import styled from 'styled-components';
import { sm } from '../../../BreakPoints';

export const Container = styled.div`
	position: relative;
	overflow: hidden;
	background:
		radial-gradient(circle at 8% 10%, rgba(59, 99, 247, 0.16), transparent 26%),
		radial-gradient(circle at 92% 8%, rgba(46, 196, 182, 0.16), transparent 26%),
		linear-gradient(180deg, var(--ice-blue) 0%, var(--surface-white) 100%);
	min-height: 100vh;
	width: 100%;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background-image: linear-gradient(rgba(136, 150, 179, 0.06) 1px, transparent 1px),
			linear-gradient(90deg, rgba(136, 150, 179, 0.06) 1px, transparent 1px);
		background-size: 34px 34px;
		mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.32), transparent 75%);
		pointer-events: none;
	}
`;

export const Wrapper = styled.div`
	max-width: 1120px;
	margin: 0 auto;
	padding: 3.6rem 1.2rem 1.3rem;
	display: grid;
	gap: 1rem;
	position: relative;
	z-index: 1;

	${sm({
		padding: '3.3rem 0.75rem 1rem',
		gap: '0.75rem',
	})}
`;

export const HeroPanel = styled.section`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem 1.1rem;
	border-radius: 1rem;
	background: linear-gradient(132deg, var(--deep-navy), var(--deep-navy-soft));
	color: var(--surface-white);
	box-shadow: 0 14px 28px rgba(26, 35, 64, 0.22);

	${sm({
		flexDirection: 'column',
		alignItems: 'flex-start',
		padding: '0.9rem',
	})}
`;

export const HeroTextGroup = styled.div`
	display: grid;
	gap: 0.26rem;
`;

export const Eyebrow = styled.p`
	margin: 0;
	font-size: 0.72rem;
	font-weight: 800;
	letter-spacing: 0.09em;
	text-transform: uppercase;
	color: rgba(255, 255, 255, 0.82);
`;

export const Title = styled.h1`
	cursor: default;
	font-weight: 700;
	font-size: 1.55rem;
	text-align: left;
	margin: 0;
	color: var(--surface-white);
	user-select: none;
`;

export const SubTitle = styled.p`
	margin: 0;
	color: rgba(255, 255, 255, 0.88);
	font-size: 0.86rem;
`;

export const BoardCount = styled.p`
	margin: 0.25rem 0 0;
	color: rgba(255, 255, 255, 0.78);
	font-size: 0.78rem;
	font-weight: 600;
`;

export const CreateNowButton = styled.button`
	border: none;
	border-radius: 0.62rem;
	padding: 0.68rem 0.92rem;
	background: var(--surface-white);
	color: var(--brand-blue);
	font-family: var(--font-display);
	font-size: 0.86rem;
	font-weight: 700;
	cursor: pointer;
	white-space: nowrap;
	transition: transform 0.18s ease, box-shadow 0.18s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 8px 16px rgba(9, 20, 42, 0.22);
	}
`;

export const BoardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
	gap: 0.9rem;
	align-content: flex-start;

	${sm({
		gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
		gap: '0.6rem',
	})}
`;

export const EmptyState = styled.p`
	margin: 0;
	padding: 1rem;
	border-radius: 0.75rem;
	border: 1px solid var(--line-mid);
	background: rgba(255, 255, 255, 0.78);
	color: var(--text-muted);
	font-size: 0.88rem;
`;

export const Board = styled.button`
	position: relative;
	overflow: hidden;
	color: var(--surface-white);
	padding: 0.75rem;
	width: 100%;
	height: 122px;
	border-radius: 0.75rem;
	border: 1px solid rgba(219, 234, 254, 0.7);
	text-align: left;
	font-size: 1.02rem;
	font-weight: 600;
	${(props) =>
		props.isImage
			? 'background-image: linear-gradient(180deg, rgba(26, 35, 64, 0.12), rgba(26, 35, 64, 0.62)), url(' +
			  props.link +
			  ');'
			: 'background-color: ' + props.link + ';'}
	background-position: center center;
	background-size: cover;
	box-shadow: rgba(7, 26, 63, 0.14) 0 8px 16px;
	cursor: pointer;
	transition: transform 180ms ease, box-shadow 180ms ease;
	text-shadow: 0 1px 3px rgba(0, 0, 0, 0.42);
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;

	&:hover {
		transform: translateY(-2px);
		box-shadow: rgba(7, 26, 63, 0.2) 0 12px 20px;
	}
`;

export const AddBoard = styled(Board)`
	background: linear-gradient(130deg, var(--brand-blue), var(--brand-blue-strong));
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	font-size: 0.98rem;
	font-weight: 700;
	text-shadow: none;
`;
